import { dataMember, required, typedArray } from 'santee-dcts';

export type AudienceRoleName = 'Investigator' | 'Sponsor' | 'Admin' | 'Internal' | 'System Admin';

export class AudienceRole {
    @dataMember({ customDeserializer: (value: string): AudienceRoleName => value as AudienceRoleName })
    @required({ nullable: true})
    public name: AudienceRoleName;

    @dataMember()
    @required({ nullable: true})
    public description: string;

    @dataMember()
    @required()
    public isExternal: boolean;

    public toString(): string {
        return this.name;
    }
}

export class AudienceRoleReadModel {
    @dataMember()
    @required()
    @typedArray(AudienceRole)
    public audienceRoles: AudienceRole[];
}
